import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
import Display from "../display/display";
const Manageagzaa = ({ userData }) => {
  const [key, setKey] = useState("enter");
  const [Datee, setDate] = useState("");
  const [DateFrom, setDateFrom] = useState("");
  const [DateTo, setDateTo] = useState("");
  const [TimeFrom, setTimeFrom] = useState("");
  const [TimeTo, setTimeTo] = useState("");
  const [Request, setRequest] = useState("");
  const [ApprovedById, setApprovedById] = useState(false);
  // const NumberOfHours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [NumberOfDays, setNumberOfDays] = useState("");
  const [NumberOfAvaDays, setNumberOfAvaDays] = useState("");

  const [NumberOfHours, setNumberOfHours] = useState("");
  // const NumberOfDays = [
  //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  //   22, 23, 24, 25, 26, 27, 28, 29,
  // ];
  const Months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [time, settime] = useState("");
  const [Day, setDay] = useState("");
  const [showCircleType, setshowCircleType] = useState(false);
  const [showSefam, setshowSefam] = useState(false);
  const [Chosedur, setChosedur] = useState("");
  const [duration, setDuration] = useState(null);
  const [showSefak, setshowSefak] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [NoteFile, setNoteFile] = useState("");
    const [BorrowValue, setBorrowValue] = useState("");

  const [Note, setNote] = useState("");
  const [FileeBase64, setBase64] = useState("");
  const [EmployeesId, setEmployeesId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [Eye, setEye] = useState(false);
  const [AdminrequestId, setAdminrequestId] = useState(userData.id);
  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة طلبات إدارية</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="طلب إداري">
                <Enter
                  key={key}
                  setKey={setKey}
                  Datee={Datee}
                  setDate={setDate}
                  BorrowValue={BorrowValue}
                  setBorrowValue={setBorrowValue}
                  DateFrom={DateFrom}
                  setDateFrom={setDateFrom}
                  DateTo={DateTo}
                  setDateTo={setDateTo}
                  TimeFrom={TimeFrom}
                  setTimeFrom={setTimeFrom}
                  TimeTo={TimeTo}
                  setTimeTo={setTimeTo}
                  Request={Request}
                  setRequest={setRequest}
                  ApprovedById={ApprovedById}
                  setApprovedById={setApprovedById}
                  NumberOfHours={NumberOfHours}
                  NumberOfDays={NumberOfDays}
                  setNumberOfDays={setNumberOfDays}
                  setNumberOfHours={setNumberOfHours}
                  Months={Months}
                  time={time}
                  settime={settime}
                  Day={Day}
                  setDay={setDay}
                  showCircleType={showCircleType}
                  setshowCircleType={setshowCircleType}
                  showSefam={showSefam}
                  setshowSefam={setshowSefam}
                  Chosedur={Chosedur}
                  setChosedur={setChosedur}
                  duration={duration}
                  setDuration={setDuration}
                  showSefak={showSefak}
                  setshowSefak={setshowSefak}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  NoteFile={NoteFile}
                  setNoteFile={setNoteFile}
                  Note={Note}
                  setNote={setNote}
                  FileeBase64={FileeBase64}
                  setBase64={setBase64}
                  EmployeesId={EmployeesId}
                  setEmployeesId={setEmployeesId}
                  isEdit={isEdit}
                  setIsEdit={setIsEdit}
                  Eye={Eye}
                  setEye={setEye}
                  AdminrequestId={AdminrequestId}
                  setAdminrequestId={setAdminrequestId}
                  userData={userData}
                  NumberOfAvaDays={NumberOfAvaDays}
                  setNumberOfAvaDays={setNumberOfAvaDays}
                />
              </Tab>
              {/* <Tab eventKey="money" title="ماليات">
                <Money />
              </Tab> */}
              <Tab eventKey="display" title="عرض">
                <Display
                  key={key}
                  setKey={setKey}
                  Datee={Datee}
                  BorrowValue={BorrowValue}
                  setBorrowValue={setBorrowValue}
                  setDate={setDate}
                  DateFrom={DateFrom}
                  setDateFrom={setDateFrom}
                  DateTo={DateTo}
                  setDateTo={setDateTo}
                  TimeFrom={TimeFrom}
                  setTimeFrom={setTimeFrom}
                  TimeTo={TimeTo}
                  setTimeTo={setTimeTo}
                  Request={Request}
                  setRequest={setRequest}
                  ApprovedById={ApprovedById}
                  setApprovedById={setApprovedById}
                  NumberOfHours={NumberOfHours}
                  NumberOfDays={NumberOfDays}
                  Months={Months}
                  time={time}
                  settime={settime}
                  Day={Day}
                  setDay={setDay}
                  showCircleType={showCircleType}
                  setshowCircleType={setshowCircleType}
                  showSefam={showSefam}
                  setshowSefam={setshowSefam}
                  Chosedur={Chosedur}
                  setChosedur={setChosedur}
                  duration={duration}
                  setDuration={setDuration}
                  showSefak={showSefak}
                  setshowSefak={setshowSefak}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  NoteFile={NoteFile}
                  setNoteFile={setNoteFile}
                  Note={Note}
                  setNote={setNote}
                  FileeBase64={FileeBase64}
                  setBase64={setBase64}
                  EmployeesId={EmployeesId}
                  setEmployeesId={setEmployeesId}
                  isEdit={isEdit}
                  setIsEdit={setIsEdit}
                  Eye={Eye}
                  setEye={setEye}
                  AdminrequestId={AdminrequestId}
                  setAdminrequestId={setAdminrequestId}
                />
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Manageagzaa;
